import React from "react";
import "./Blogs.css";
import { Fade } from "react-reveal";
import { blogs, blogsHeading } from "../../portfolio";
import BlogPost from "../../components/blogpost/BlogPost";

export default function Blogs() {
    return (
        <Fade bottom duration={1000} distance="20px">
            <div className="main contact-margin-top" id="contact">
                <div className="contact-div-main">
                    <div className="contact-header">
                        <h1 className="heading contact-title">{blogsHeading.title}</h1>
                        {/* <p className="subTitle contact-subtitle">{blogsHeading.subtitle}</p> */}

                        <div className="contact-text-div">
                        {blogs.map((blog) => {
                            return (
                                <BlogPost
                                    blog={{
                                     ...blog
                                    }}
                                />
                            );
                        })}
                        </div>
                    </div>
                    {/* <div className="contact-image-div">
                    <img alt="Saad Working" src={require("../../assets/images/contactMail.webp")}></img>
                </div> */}
                </div>
            </div>
        </Fade>
    );
}
